"use client";

import { RequiredBuyPremiumButton } from "@/app/_components/required/buy-premium-button";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";

import { useActions } from "./use-actions";
import { useUser } from "@clerk/nextjs";
import { getUserPlanByMetadata } from "@/helper/user/client";

export const ListSearch = () => {
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);
  const {
    handler,
    state: { pesquisa },
  } = useActions();

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handler.search();
  };

  const change = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (hasPaidPlan) {
      handler.setSearchParam({ pesquisa: e.target.value });
    }
  };

  return (
    <form
      role="search"
      className="w-full sm:w-[420px] mx-auto"
      onSubmit={submit}
    >
      <div className="relative">
        <div className="absolute top-2.5 left-2">
          <MagnifyingGlassIcon
            className="mr-2 size-4 text-muted-foreground opacity-50"
            aria-hidden="true"
          />
        </div>
        <RequiredBuyPremiumButton enabled={hasPaidPlan}>
          <Input
            type="search"
            placeholder="Buscar endereço, bairro..."
            className="w-full sm:min-w-72 pl-7 pr-10"
            value={pesquisa || ""}
            onChange={change}
          />
        </RequiredBuyPremiumButton>
        <div
          className={cn(
            "absolute top-0.5 right-1",
            pesquisa ? "block" : "hidden"
          )}
        >
          <Button
            type="button"
            variant="secondary"
            size="icon"
            className="h-8 w-8"
            onClick={handler.cleanSearch}
          >
            <XMarkIcon className="size-4" aria-hidden="true" />
          </Button>
        </div>
      </div>
    </form>
  );
};
